import { Injectable } from '@angular/core';
import Auth, { CognitoUser } from '@aws-amplify/auth';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthContext {
  private userData$ = new BehaviorSubject<CognitoUser | null>(null);

  setUser(userData: CognitoUser) {
    this.userData$.next(userData);
  }

  getUser() {
    return this.userData$.getValue();
  }

  getUid(): string | undefined {
    const tokenPayload = this.userData$.getValue()?.getSignInUserSession()?.getAccessToken().decodePayload();
    return tokenPayload?.sub;
  }

  async getAccessToken() {
    return new Promise((resolve) => {
      Auth.currentSession()
        .then((data) => {
          resolve(data.getAccessToken().getJwtToken());
        })
        .catch((error) => {
          console.error(error);
          resolve(null);
        });
    });
  }

  get userData() {
    return this.userData$.asObservable();
  }
}
